import settings from 'config/settings'
import React, { useRef, useState } from 'react'
import './VerifyOtp.css'
import image from './touche logo.png'

const VerifyOtp: React.FC = () => {
  const [otp, setOtp] = useState<string[]>(Array(6).fill(''))
  const [error, setError] = useState<string>('')
  const [success, setSuccess] = useState<string>('')
  const inputRefs = useRef<Array<HTMLInputElement | null>>([])

  const handleInput = (index: number, e: React.FormEvent<HTMLInputElement>) => {
    const value = (e.target as HTMLInputElement).value.replace(/\D/g, '')
    if (value) {
      const newOtp = [...otp]
      newOtp[index] = value.slice(-1)
      setOtp(newOtp)

      if (index < 5) {
        const input = inputRefs.current[index + 1]
        if (input) {
          input.focus()
        }
      }
    }
  }

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace') {
      e.preventDefault()
      const newOtp = [...otp]

      if (otp[index]) {
        newOtp[index] = ''
      } else if (index > 0) {
        newOtp[index - 1] = ''
        const input = inputRefs.current[index - 1]
        if (input) {
          input.focus()
        }
      }

      setOtp(newOtp)
    }
  }

  const getSearchParams = () => {
    const params = window.location.search
    const email = new URLSearchParams(params).get('email')
    return { email }
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const enteredOtp = otp.join('')

    if (!getSearchParams().email) {
      setError('Email address not found. Please try again.')
      return
    }

    if (enteredOtp.length !== 6) {
      setError('Please enter a valid 6-digit OTP.')
      return
    }

    setError('')

    try {
      const apiUrl = `${settings.userApi}/otpVerify`

      const emailAddress = getSearchParams().email

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          emailAddress,
          otpStore: enteredOtp
        })
      })

      if (!response.ok) {
        const errorResponse = await response.json()
        throw new Error(errorResponse.error || 'Failed to verify OTP. Please try again.')
      }

      const successResponse = await response.json()

      setTimeout(() => {
        setSuccess('')
        setOtp(Array(6).fill(''))
        const input = inputRefs.current[0]
        if (input) {
          input.focus()
        }
        window.location.href = 'https://marketplace-admin-dev.system.touchetv.com/shopify/login'
      }, 3000)
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message || 'Something went wrong. Please try again.')
      } else {
        setError('An unknown error occurred.')
      }
    }
  }

  return (
    <div className='container'>
      <div style={{ width: '400px' }}>
        <h2>Enter OTP</h2>
        <div style={{ marginBottom: '50px', marginTop: '50px' }}>
          <img width={375} height={75} src={image} alt='Logo' className='delete-account-logo' />
        </div>
        <form onSubmit={handleSubmit} className='form'>
          <div className='otp-group' style={{ marginTop: '100px', marginBottom: '20px' }}>
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type='text'
                maxLength={1}
                value={digit}
                onInput={(e) => handleInput(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                inputMode='numeric'
              />
            ))}
          </div>
          {error && <p className='error' style={{ textAlign: 'center', width: '100%', lineHeight: 'normal', marginBottom: '10px' }} >{error}</p>}
          {success && <p className='success' style={{ textAlign: 'center', width: '100%', lineHeight: 'normal', marginBottom: '10px' }}>{success}</p>}
          <button style={{ marginTop: '20px' }} type='submit' disabled={otp.join('').length !== 6} className='delete-account-verify-btn'>Verify</button>
        </form>
      </div>
    </div>
  )
}

export default VerifyOtp
